import React from 'react';
import Input from '../form-elements/Input';
import * as Yup from 'yup';
import { apiClient } from '../../../helpers/apiHelperV2';
import SalutationInformation, { mergeSalutationInformationInitialValues, SalutationInformationSchemaFields } from './SalutationInformation';

function PersonalInformation({ errors, touched, values, onChange, onBlur }) {
    return (
        <>
            <SalutationInformation errors={errors} touched={touched} values={values} onChange={onChange} onBlur={onBlur} />
            <Input
                name="street"
                id="street"
                value={values.street}
                label="Straße und Hausnummer *"
                placeholder="Straße und Hausnummer"
                onChange={onChange}
                onBlur={onBlur}
                error={touched.street && errors.street ? errors.street : undefined}
                autoComplete="address-line1"
                aria-required="true"
                aria-invalid={touched.street && errors.street ? 'true' : 'false'}
                aria-describedby={touched.street && errors.street ? 'street-error' : undefined}
            />
            <Input
                name="additionalAddress"
                id="additionalAddress"
                value={values.additionalAddress}
                label="Adresszusatz"
                placeholder="Adresszusatz"
                onChange={onChange}
                onBlur={onBlur}
                autoComplete="address-line2"
            />
            <div className="uk-margin uk-grid-small uk-grid" data-uk-grid="">
                <div className="uk-width-1-3@s">
                    <Input
                        name="zipCode"
                        id="zipCode"
                        value={values.zipCode}
                        label="Postleitzahl *"
                        placeholder="Postleitzahl"
                        onChange={onChange}
                        onBlur={onBlur}
                        error={touched.zipCode && errors.zipCode ? errors.zipCode : undefined}
                        autoComplete="postal-code"
                        aria-required="true"
                        aria-invalid={touched.zipCode && errors.zipCode ? 'true' : 'false'}
                        aria-describedby={touched.zipCode && errors.zipCode ? 'zipCode-error' : undefined}
                    />
                </div>
                <div className="uk-width-expand">
                    <Input
                        name="city"
                        id="city"
                        value={values.city}
                        label="Ort *"
                        placeholder="Ort"
                        onChange={onChange}
                        onBlur={onBlur}
                        error={touched.city && errors.city ? errors.city : undefined}
                        autoComplete="address-level2"
                        aria-required="true"
                        aria-invalid={touched.city && errors.city ? 'true' : 'false'}
                        aria-describedby={touched.city && errors.city ? 'city-error' : undefined}
                    />
                </div>
            </div>
            <Input
                name="country"
                id="country"
                value={values.country}
                label="Land *"
                placeholder="Land"
                onChange={onChange}
                onBlur={onBlur}
                error={touched.country && errors.country ? errors.country : undefined}
                disabled
                autoComplete="off"
                aria-required="true"
                aria-invalid={touched.country && errors.country ? 'true' : 'false'}
                aria-describedby={touched.country && errors.country ? 'country-error' : undefined}
            />
        </>
    );
}

export default PersonalInformation;

export const PersonalInformationSchemaFields = {
    ...SalutationInformationSchemaFields,
    street: Yup.string().required('Pflichtfeld'),
    additionalAddress: Yup.string(),
    zipCode: Yup.string()
        .required('Pflichtfeld')
        .test('zipCode', 'Bitte geben Sie eine gültige deutsche PLZ ein', async function (zipCode) {
            if (zipCode && zipCode.length === 5) {
                try {
                    const {
                        data: { isValid },
                    } = await apiClient.post('/api/v1/validation/zipCode', { zipCode });
                    return isValid;
                } catch (err) {
                    console.error(err);
                    return false;
                }
            }
        }),
    city: Yup.string().required('Pflichtfeld'),
    country: Yup.string().equals(['Deutschland']),
};

export const mergePersonalInformationInitialValues = values => ({
    ...mergeSalutationInformationInitialValues(values),
    street: values?.street ?? '',
    additionalAddress: values?.additionalAddress ?? '',
    zipCode: values?.zipCode ?? '',
    city: values?.city ?? '',
    country: 'Deutschland',
});
